// extracted by mini-css-extract-plugin
export default {"logoLink":"ddbpxdMp"};